import React from "react";
import { Archive, Copy, Eye, Network, Pencil, Trash2, Upload } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Trigger list. Write actions are shown only when `canManage` (Super Admin).
// `busy` = { id, action } of a request in flight.
export default function TriggerRowActions({ row, canManage, busy, onView, onUsedBy, onEdit, onClone, onPublish, onArchive, onDelete }) {
  const isBusy = (action) => busy?.id === row.id && busy.action === action;
  const anyBusy = busy?.id === row.id;
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} busy={isBusy("view")} disabled={anyBusy} />
      <IconAction label="Used by" icon={Network} onClick={() => onUsedBy(row)} busy={isBusy("used-by")} disabled={anyBusy} />
      {canManage && (
        <>
          <IconAction label="Edit" icon={Pencil} tone="primary" onClick={() => onEdit(row)} disabled={anyBusy} />
          <IconAction label="Copy as a draft" icon={Copy} onClick={() => onClone(row)} busy={isBusy("clone")} disabled={anyBusy} />
          {row.status !== "ACTIVE" && <IconAction label={row.version_no ? "Publish again" : "Publish"} icon={Upload} tone="primary" onClick={() => onPublish(row)} busy={isBusy("publish")} disabled={anyBusy} />}
          {row.status !== "ARCHIVED" && <IconAction label="Archive" icon={Archive} onClick={() => onArchive(row)} busy={isBusy("archive")} disabled={anyBusy} />}
          {!row.is_system && <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} disabled={anyBusy} />}
        </>
      )}
    </div>
  );
}
